import React from "react";

const ResumenEstadosPedidos = ({ data }) => {
  // Orden deseado de los estados
  const ordenEstados = [
    "CREADO",
    "LE_OK",
    "LE_APROBADA",
    "PARCIAL ASIG",
    "PARCIAL CARG",
    "PARCIAL DESP",
  ];

  // Agrupa los pedidos por estado y cuenta cuántos hay en cada uno
  const estadosTotales = data.reduce((acc, row) => {
    const estado = row.sNombreEstadoPedido || "Desconocido";
    acc[estado] = (acc[estado] || 0) + 1;
    return acc;
  }, {});

  // Convierte el objeto en un array y lo ordena según el orden deseado
  const estadosOrdenados = Object.entries(estadosTotales).sort(
    ([estadoA], [estadoB]) =>
      ordenEstados.indexOf(estadoA) - ordenEstados.indexOf(estadoB),
  );

  // Función para renderizar el ícono según el estado
  const renderIconoEstado = (estado) => {
    switch (estado) {
      case "CREADO":
        return <i className="pi pi-file p-mr-2"></i>;
      case "LE_OK":
        return <i className="pi pi-circle p-mr-2"></i>;
      case "LE_APROBADA":
        return <i className="pi pi-check-circle p-mr-2"></i>;
      case "PARCIAL ASIG":
        return <i className="pi pi-folder-open p-mr-2"></i>;
      case "PARCIAL CARG":
        return <i className="pi pi-box p-mr-2"></i>;
      case "PARCIAL DESP":
        return <i className="pi pi-truck p-mr-2"></i>;
      default:
        return <i className="pi pi-info-circle p-mr-2"></i>;
    }
  };

  return (
    <div className="resumen-estados-panel">
      {estadosOrdenados.map(([estado, cantidad], index) => (
        <div key={index} className="resumen-estado-item">
          {renderIconoEstado(estado)}
          <span>
            <strong>{estado}:</strong> {cantidad}
          </span>
        </div>
      ))}
    </div>
  );
};

export default ResumenEstadosPedidos;
